export default __webpack_public_path__ + "static/media/ppnTherapist2Small.7a3be8ec.jpg";